import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'estructura-organizacional/centros-de-costos/';

/**
 * GET centros-de-costos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCentrosDeCostos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
